'use strict';

var configCtrl = ["$translate", "toast", "Upload",'$scope', function ($translate, toast, Upload,$scope) {
    var _this = this;
    this.elementsTypeToFilter = ['text', "select", 'formula', 'number'];
    this.elementsList = require('./dashboardGraphBuilderElements')($translate);

    this.getAllElementsForm = function (typeElement) {
        let formSelected = this.forms.find(function (form) { return (form.id == _this.element.templateData.optionsDS.formId) });
        if (formSelected && formSelected.pages)
            return formSelected.pages.flatMap(page => {
                return page.fields.filter((ele) => typeElement.includes(ele.type))
                    .concat(page.fields.filter((ele) => ele.nodes != undefined)
                        .flatMap(group => group.nodes));
            })
        return [];

    }
    //temporal function to handle requires...
    this.getElements = function (container, type) {
        return [{
            name: '',
            type: ''
        }].concat(container.pages.flatMap(page => {
            return page.fields.filter((ele) => ele.type === type && ele.name)
                .concat(page.fields.filter((ele) => ele.nodes != undefined)
                    .flatMap(group => group.nodes.filter(node => node.type === type && node.name)));
        }));
    };

    this.getDS = function () {
        return this.getElements(_this.graph, "datasource");
    }

    this.getColumnsOfDS = function (type) {
        let ds = this.getElements(_this.graph, "datasource").find(d => d.id == _this.element.templateData.datasourceElementId);
        let lstColumns = Object.values(ds.templateData.datasource.elements).filter(el => (type == undefined || el.type == type));
        return lstColumns.map(e => e.name || e.label);
    }

    this.uploadFiles = function (file, errFile, destino) {
        if (file) {
            const reader = new FileReader;
            reader.onload = () => {
                console.log(reader.result);
                _this.element.templateData = _this.element.templateData || {};
                _this.element.templateData[destino] = reader.result;
            };
            reader.readAsDataURL(file);

        }
    };

    this.refreshDataSources = function () {
        const next = _this.getElements(_this.graph, 'datasource');
        const prev = _this.lstDataSources || [];
        // Evitar reasignar el array si no cambió: regenerar ng-options en Firefox
        const unchanged = prev.length === next.length && prev.every(function (ds, i) {
            return ds && next[i] && ds.id === next[i].id && ds.name === next[i].name;
        });
        if (!unchanged) {
            _this.lstDataSources = next;
        }
    };

    this.onDatasourceSelect = function() {
        const selectedDatasourceId = _this.element.templateData.datasourceElementId;

        if (selectedDatasourceId) {
            const selectedDatasource = (_this.lstDataSources || []).find(function(ds) {
                return ds.id === selectedDatasourceId;
            });

            if (selectedDatasource) {
                const dsCfg = selectedDatasource.templateData && selectedDatasource.templateData.datasource;
                if (dsCfg && dsCfg.type == 'query' && dsCfg.elements && dsCfg.elements.id && dsCfg.elements.id.name) {
                    _this.element.templateData.idReport = dsCfg.elements.id.name;
                }
            } else {
                console.log('No se encontró el DataSource con ID:', selectedDatasourceId);
            }
        } else {
            console.log('No hay DataSource seleccionado.');
            _this.element.templateData.idReport = null;
        }
    };

    // Inicialización de width
    this.initializeWidthConfig = function() {
        // Si no existe widthMode => configuracion antigua con fracciones
        if (!_this.element.widthMode) {
            _this.element.widthMode = 'fraction';
            // Cargar partsOfWindowWidth
            if (!_this.element.partsOfWindowWidth) {
                _this.element.partsOfWindowWidth = 2; // valor por defecto de fraccion
            }
        }
        
        // Valor por defecto de porcentaje
        if (_this.element.widthMode === 'percentage' && !_this.element.widthPercentage) {
            _this.element.widthPercentage = 100;
        }
    };

    // Inicialización de Height (Altura)
    this.initializeHeightConfig = function() {
        // Si no existe heightMode, significa que es un elemento viejo con fracciones
        if (!_this.element.heightMode) {
            _this.element.heightMode = 'fraction';
            // Cargar partsOfWindowHeight
            if (!_this.element.partsOfWindowHeight) {
                _this.element.partsOfWindowHeight = 1; // valor por defecto de fraccion
            }
        }
        
        // Valor por defecto de porcentaje
        if (_this.element.heightMode === 'percentage' && !_this.element.heightPercentage) {
            _this.element.heightPercentage = 100;
        }
    };

    this.onWidthModeChange = function() {
        if (_this.element.widthMode === 'percentage' && !_this.element.widthPercentage) {
            _this.element.widthPercentage = 100;
        } else if (_this.element.widthMode === 'fraction' && !_this.element.partsOfWindowWidth) {
            _this.element.partsOfWindowWidth = 1;
        }
    };

    this.onHeightModeChange = function() {
        if (_this.element.heightMode === 'percentage' && !_this.element.heightPercentage) {
            _this.element.heightPercentage = 100;
        } else if (_this.element.heightMode === 'fraction' && !_this.element.partsOfWindowHeight) {
            _this.element.partsOfWindowHeight = 1;
        }
    };

    _this.triggerChildToggle = function() {
        _this.element.allOpen = !_this.element.allOpen;
        $scope.$broadcast('datasource:toggle', 'all');
    };

    _this.refreshDataSources();

    // Mantener la lista al día sin tocar el <select>
    $scope.$watch(function () {
        if (!_this.graph || !_this.graph.pages) {
            return '';
        }
        return _this.graph.pages.map(function (page) {
            return (page.fields || []).filter(function (f) {
                return f.type === 'datasource';
            }).map(function (f) {
                return (f.id || '') + ':' + (f.name || '');
            }).join(',');
        }).join('|');
    }, function () {
        _this.refreshDataSources();
    });

    this.initializeWidthConfig();
    this.initializeHeightConfig();

    // console.log('graphConfigDirective 3 this.integrations', this.integrations);
    // console.log('graphConfigDirective 3 this.departmentforms', this.departmentforms);
    // console.log('departmentforms en graph', _this.departmentforms)
}];

module.exports = function () {
    return {
        restrict: 'E',
        scope: {
            element: '=',
            open: '=',
            graph: '=',
            forms: '=',
            integrations: '=',
            departmentforms: '=',
        },
        replace: true,
        controller: configCtrl,
        controllerAs: 'ctrl',
        bindToController: true,
        templateUrl: 'dashboard-graphBuilder/graphConfigDirective.html'
    };
};